var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var IMAGE_FILE_TYPES = ['image/jpg', 'image/png', 'image/svg', 'image/jpeg'];
export var getImageDimensions = function (file) {
    return new Promise(function (resolve) {
        var url = URL.createObjectURL(file);
        var image = new Image();
        image.src = url;
        image.onload = function () {
            var height = image.height, width = image.width;
            URL.revokeObjectURL(url);
            resolve({ height: height, width: width });
        };
    });
};
export var isLowResolution = function (width, height, uploadImageMinWidth, uploadImageMinHeight) {
    return width < uploadImageMinWidth || height < uploadImageMinHeight;
};
export var isImageTypeValid = function (imageFile) {
    var fileType = imageFile.type;
    var isImage = IMAGE_FILE_TYPES.includes(fileType);
    return isImage ? true : false;
};
export var isImageDimensionValid = function (imageFile, uploadImageMinWidth, uploadImageMinHeight) { return __awaiter(void 0, void 0, void 0, function () {
    var imageInfo, width, height, lowResolution;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getImageDimensions(imageFile)];
            case 1:
                imageInfo = _a.sent();
                width = imageInfo.width;
                height = imageInfo.height;
                lowResolution = isLowResolution(width, height, uploadImageMinWidth, uploadImageMinHeight);
                return [2 /*return*/, lowResolution ? false : true];
        }
    });
}); };
export var createImage = function (url) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.addEventListener('load', function () { return resolve(image); });
        image.addEventListener('error', function (error) { return reject(error); });
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = url;
    });
};
export var imgUrlToBase64 = function (imgUrl, handleBase64Loaded) { return __awaiter(void 0, void 0, void 0, function () {
    var data, blob;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(imgUrl)];
            case 1:
                data = _a.sent();
                return [4 /*yield*/, data.blob()];
            case 2:
                blob = _a.sent();
                imgBlobToBase64(blob, handleBase64Loaded);
                return [2 /*return*/];
        }
    });
}); };
export var imgBlobToBase64 = function (blob, handleBase64Loaded) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
        var base64data = reader.result;
        handleBase64Loaded(base64data);
    };
};
// To calculate the minimum value of zoom so that no extra white space
// appears in the cropper
export var calculateMinZoom = function (imgWidth, imgHeight, MODAL_CONTENT_HEIGHT, MODAL_CONTENT_WIDTH, cropperHeight, cropperWidth) {
    // find ratio between img widht/height and modal content width / height
    var modalContentImgHeightRatio = imgHeight / MODAL_CONTENT_HEIGHT;
    var modalContentImgWidthRatio = imgWidth / MODAL_CONTENT_WIDTH;
    // find the larger ratio
    var maxRatio = modalContentImgWidthRatio > modalContentImgHeightRatio
        ? modalContentImgWidthRatio
        : modalContentImgHeightRatio;
    // if width ratio is larger, when zoom out to 1,
    // width will take up the whole width of the modal,
    // height will then produce white space since
    // its imgHeight / contentHeight ratio is smaller
    // setting the minSizeRestraint to be imgHeight will make sure
    // imgHeight will take up the whole height of the modal with no white space
    var minSizeRestraint = modalContentImgWidthRatio > modalContentImgHeightRatio
        ? imgHeight
        : imgWidth;
    // determine which varaible will be the cropper's size restraint
    var minRestraintCropperVariable = modalContentImgWidthRatio > modalContentImgHeightRatio
        ? cropperHeight
        : cropperWidth;
    // find the minimum pixel value of the restraint variable
    // when img is zoomed out to 1
    var minPixel = minSizeRestraint / maxRatio;
    // find the minimum zoom possible so that no white space appears
    var cropMinZoom = minRestraintCropperVariable / minPixel;
    // rounding ratio to the nearest 1 decimal
    var roundedCropMinZoom = parseFloat(cropMinZoom.toFixed(1));
    return roundedCropMinZoom;
};
